@if (filled()) {
  <span class="select-label">
    {{ label() | upperFirstLetter }}
    @if (required()) {
      <span class="required">*</span>
    }
  </span>
}
<ng-content />
@if (errorMessage()) {
  <p class="field-error">{{ errorMessage() }}</p>
}
